import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import {
  mailSending,
  mailWorkorderList,
  sendMail,
} from './MailControler.service';
import { MailListRequestParams } from './MailControler.types';

const QUERY_KEY = 'mails/workorder';

const mailErrors: Record<string, string> = {
  'Mail Configuration not Found': 'Não foi encontrado a configuração de e-mail',
  invalidEmail: 'E-mail inválido',
};

export function useMailWorkorderList(params?: MailListRequestParams) {
  return useInfiniteQuery(
    [QUERY_KEY, params],
    ({ pageParam }) =>
      mailWorkorderList({
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      }),
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
      onError(error) {
        notificationError(error, {
          message: 'Listagem de e-mails',
          description: 'Não foi possível listar os registros.',
        });
      },
    },
  );
}

export function useMailSending() {
  const queryClient = useQueryClient();

  return useMutation(mailSending, {
    onSuccess() {
      queryClient.invalidateQueries([QUERY_KEY]);
      notification.success({
        message: 'E-mail enviado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error, {
        message: 'Envio de e-mail',
        description: 'Não foi possível enviar o e-mail.',
      });
    },
  });
}

export function useMailSend() {
  const queryClient = useQueryClient();

  return useMutation(sendMail, {
    onSuccess() {
      queryClient.invalidateQueries([QUERY_KEY]);
      notification.success({
        message: 'E-mail enviado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error, {
        message: 'Envio de e-mail',
        description: 'Não foi possível enviar o e-mail.',
        translate: (errors) =>
          errors.map((err) =>
            mailErrors[err] || err.includes('Recipient e-mail is invalid')
              ? mailErrors['invalidEmail']
              : err,
          ),
      });
    },
  });
}
